/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";
import TableList from "views/Tables.js";
import Maps from "views/Map.js";
import UserPage from "views/User.js";
import PhoneLogin from "./views/phoneLogin";
import Add from "views/add";


import { FaHotel} from 'react-icons/fa';
import { AiFillSetting }from 'react-icons/ai';
import {RiOrderPlayLine }from 'react-icons/ri';
import { MdPayment }from 'react-icons/md';
import {MdSpaceDashboard}from 'react-icons/md';
import {CgProfile}from 'react-icons/cg';


var routes = [
 
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <MdSpaceDashboard size={18} />,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/icons",
    name: "Add branch",
    icon: <FaHotel size={18} /> ,
    component: Add,

    layout: "/admin",
  },
  {
    path: "/maps",
    name: "Manage Branches",
    icon: <AiFillSetting size={18} />  ,
    component: Maps,
    layout: "/admin",
  },

  {
    path: "/user-page",
    name: "Booking",
    icon: <RiOrderPlayLine size={18} /> ,
    component: UserPage,
    layout: "/admin",
  },
  {
    path: "/tables",
    name: "Payment",
    icon: <MdPayment size={18}/>,
    component: TableList,
    layout: "/admin",
  },
  
];
export default routes;
